import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

const PageLayout = React.forwardRef(({ classes, children, grey, padding, withTabs, withDrawer, withChips }, ref) => {
  const customPadding = padding ? { padding } : {};
  return (
    <div
      ref={ref}
      className={cx(
        classes.content,
        grey && classes.grey,
        withTabs ? classes.scrollAreaWithTabs : classes.scrollArea,
        withDrawer && classes.scrollAreaWithHeaderAndDrawer,
        withChips && classes.scrollAreaWithChips,
      )}
      style={{ ...customPadding }}
    >
      {children}
    </div>
  );
});

PageLayout.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string),
  children: PropTypes.node,
  grey: PropTypes.bool,
  withTabs: PropTypes.bool,
  withDrawer: PropTypes.bool,
};

PageLayout.defaultProps = {
  children: '',
  classes: {},
  grey: false,
  withTabs: false,
  withDrawer: false,
};

PageLayout.displayName = 'PageLayout';

export default PageLayout;
